import { render, staticRenderFns } from "./EmployeeSalaryStatementEditDetails.vue?vue&type=template&id=bad5cf3a"
import script from "./EmployeeSalaryStatementEditDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryStatementEditDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports